var map = {
	"./blog.yml": 98,
	"./cloud.yml": 99,
	"./color.yml": 100,
	"./country.yml": 101,
	"./doc.yml": 102,
	"./emoji.yml": 103,
	"./flag.yml": 104,
	"./git.yml": 105,
	"./icon.yml": 106,
	"./license.yml": 107,
	"./link.yml": 108,
	"./people.yml": 109,
	"./soft.yml": 110,
	"./src.yml": 111,
	"./status.yml": 112,
	"./taxonomy.yml": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;